import {
  CONTACT_US,
  CONTACT_US_FAILURE,
  CONTACT_US_SUCCESS,
  GET_BLOG_CATEGORIES,
  GET_BLOG_CATEGORIES_FAILURE,
  GET_BLOG_CATEGORIES_SUCCESS,
  GET_BLOGS,
  GET_BLOGS_FAILURE,
  GET_BLOGS_SUCCESS,
  GET_CLIENTS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_SUCCESS,
  GET_CONTACT_SECTION,
  GET_CONTACT_SECTION_FAILURE,
  GET_CONTACT_SECTION_SUCCESS,
  GET_PAGE_DATA,
  GET_PAGE_DATA_FAILURE,
  GET_PAGE_DATA_SUCCESS,
  GET_PROJECTS,
  GET_PROJECTS_FAILURE,
  GET_PROJECTS_SUCCESS,
  GET_PROJECT_TYPES,
  GET_PROJECT_TYPES_FAILURE,
  GET_PROJECT_TYPES_SUCCESS,
  GET_SECTION_DATA,
  GET_SECTION_DATA_FAILURE,
  GET_SECTION_DATA_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_FAILURE,
  GET_SERVICES_SUCCESS,
  GET_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
  GET_SINGLE_BLOG,
  GET_SINGLE_CATEGORY,
  GET_SINGLE_CATEGORY_FAILURE,
  GET_SINGLE_CATEGORY_SUCCESS,
  GET_SINGLE_BLOG_FAILURE,
  GET_SINGLE_BLOG_SUCCESS,
  GET_SOCIALS,
  GET_SOCIALS_FAILURE,
  GET_SOCIALS_SUCCESS,
  SUBSCRIBE_NEWSLETTER,
  SUBSCRIBE_NEWSLETTER_FAILURE,
  SUBSCRIBE_NEWSLETTER_SUCCESS,
  LOAD_MORE_BLOGS,
  LOAD_MORE_BLOGS_SUCCESS,
  LOAD_MORE_BLOGS_FAILURE,
} from "./actionTypes";

export const getPageData = (payload) => {
  return {
    type: GET_PAGE_DATA,
    payload: payload,
  };
};

export const getPageDataSuccess = (payload) => {
  return {
    type: GET_PAGE_DATA_SUCCESS,
    payload: payload,
  };
};

export const getPageDataFailure = (payload) => {
  return {
    type: GET_PAGE_DATA_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getSettings = (payload) => {
  return {
    type: GET_SETTINGS,
    payload: payload,
  };
};

export const getSettingsSuccess = (payload) => {
  return {
    type: GET_SETTINGS_SUCCESS,
    payload: payload,
  };
};

export const getSettingsFailure = (payload) => {
  return {
    type: GET_SETTINGS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const contactUs = (payload) => {
  return {
    type: CONTACT_US,
    payload: payload,
  };
};

export const contactUsSuccess = (payload) => {
  return {
    type: CONTACT_US_SUCCESS,
    payload: payload,
  };
};

export const contactUsFailure = (payload) => {
  return {
    type: CONTACT_US_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getSectionData = (payload) => {
  return {
    type: GET_SECTION_DATA,
    payload: payload,
  };
};

export const getSectionDataSuccess = (payload) => {
  return {
    type: GET_SECTION_DATA_SUCCESS,
    payload: payload,
  };
};

export const getSectionDataFailure = (payload) => {
  return {
    type: GET_SECTION_DATA_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getServices = (payload) => {
  return {
    type: GET_SERVICES,
    payload: payload,
  };
};

export const getServicesSuccess = (payload) => {
  return {
    type: GET_SERVICES_SUCCESS,
    payload: payload,
  };
};

export const getServicesFailure = (payload) => {
  return {
    type: GET_SERVICES_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getProjects = (payload) => {
  return {
    type: GET_PROJECTS,
    payload: payload,
  };
};

export const getProjectsSuccess = (payload) => {
  return {
    type: GET_PROJECTS_SUCCESS,
    payload: payload,
  };
};

export const getProjectsFailure = (payload) => {
  return {
    type: GET_PROJECTS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getBlogs = (payload) => {
  return {
    type: GET_BLOGS,
    payload: payload,
  };
};

export const getBlogsSuccess = (payload) => {
  return {
    type: GET_BLOGS_SUCCESS,
    payload: payload,
  };
};

export const getBlogsFailure = (payload) => {
  return {
    type: GET_BLOGS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getSingleBlog = (payload) => {
  return {
    type: GET_SINGLE_BLOG,
    payload: payload,
  };
};

export const getSingleBlogSuccess = (payload) => {
  return {
    type: GET_SINGLE_BLOG_SUCCESS,
    payload: payload,
  };
};

export const getSingleBlogFailure = (payload) => {
  return {
    type: GET_SINGLE_BLOG_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const subscribeNewsletter = (payload) => {
  return {
    type: SUBSCRIBE_NEWSLETTER,
    payload: payload,
  };
};
export const subscribeNewsletterSuccess = (payload) => {
  return {
    type: SUBSCRIBE_NEWSLETTER_SUCCESS,
    payload: payload,
  };
};
export const subscribeNewsletterFailure = (payload) => {
  return {
    type: SUBSCRIBE_NEWSLETTER_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getSocials = (payload) => {
  return {
    type: GET_SOCIALS,
    payload: payload,
  };
};
export const getSocialsSuccess = (payload) => {
  return {
    type: GET_SOCIALS_SUCCESS,
    payload: payload,
  };
};
export const getSocialsFailure = (payload) => {
  return {
    type: GET_SOCIALS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getClients = (payload) => {
  return {
    type: GET_CLIENTS,
    payload: payload,
  };
};
export const getClientsSuccess = (payload) => {
  return {
    type: GET_CLIENTS_SUCCESS,
    payload: payload,
  };
};
export const getClientsFailure = (payload) => {
  return {
    type: GET_CLIENTS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getContactSection = (payload) => {
  return {
    type: GET_CONTACT_SECTION,
    payload: payload,
  };
};
export const getContactSectionSuccess = (payload) => {
  return {
    type: GET_CONTACT_SECTION_SUCCESS,
    payload: payload,
  };
};
export const getContactSectionFailure = (payload) => {
  return {
    type: GET_CONTACT_SECTION_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getBlogCategories = (payload) => {
  return {
    type: GET_BLOG_CATEGORIES,
    payload: payload,
  };
};
export const getBlogCategoriesSuccess = (payload) => {
  return {
    type: GET_BLOG_CATEGORIES_SUCCESS,
    payload: payload,
  };
};
export const getBlogCategoriesFailure = (payload) => {
  return {
    type: GET_BLOG_CATEGORIES_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getSingleCategory = (payload) => {
  return {
    type: GET_SINGLE_CATEGORY,
    payload: payload,
  };
};
export const getSingleCategorySuccess = (payload) => {
  return {
    type: GET_SINGLE_CATEGORY_SUCCESS,
    payload: payload,
  };
};
export const getSingleCategoryFailure = (payload) => {
  return {
    type: GET_SINGLE_CATEGORY_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getBlogsByCategory = (payload) => {
  return {
    type: GET_BLOGS,
    payload: payload,
  };
};
export const getBlogsByCategorySuccess = (payload) => {
  return {
    type: GET_BLOGS_SUCCESS,
    payload: payload,
  };
};
export const getBlogsByCategoryFailure = (payload) => {
  return {
    type: GET_BLOGS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const loadMoreBlogs = (payload) => {
  return {
    type: LOAD_MORE_BLOGS,
    payload: payload,
  };
};

export const loadMoreBlogsSuccess = (payload) => {
  return {
    type: LOAD_MORE_BLOGS_SUCCESS,
    payload: payload,
  };
};
export const loadMoreBlogsFailure = (payload) => {
  return {
    type: LOAD_MORE_BLOGS_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================

export const getProjectTypes = (payload) => {
  return {
    type: GET_PROJECT_TYPES,
    payload: payload,
  };
};

export const getProjectTypesSuccess = (payload) => {
  return {
    type: GET_PROJECT_TYPES_SUCCESS,
    payload: payload,
  };
};

export const getProjectTypesFailure = (payload) => {
  return {
    type: GET_PROJECT_TYPES_FAILURE,
    payload: payload,
  };
};

// ==================================================
// ==================================================
